import React from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import InboxNotificationsContent from '../../features/Notifications/components/index';

export default function Notification({}) {
  return (
    <>
      <ProtectedPageSidebar />
      <InboxNotificationsContent />
    </>
  );
}
